import React from "react";
import { v4 as uuid } from "uuid";
import { Link, HashRouter as Router } from "react-router-dom";
import { AppView } from "../../views";
import { SimpleFooterPure, SimpleLoading } from "../../pures";
import {
  LocalStorageService,
  Auth0Service,
  UserDocService,
  SignerService,
  ContractService,
  ContractorService,
  ClientService,
  HelpSectionService,
  UserSignatureProfileService,
  BlogA3FirmaDigitalService,
  BovedaApi,
  UserService,
  UpdateToken,
  NotificationSocketService,
  CacheStorageService,
} from "../../../services";
import Routes from "../../../routes";
// import { LogoGovoLegal } from "../../../assets/logos/icons/index";
import { useTranslation } from "react-i18next";
import { ContextProvider, SocketContext, socket } from "../../../Context";
import CustomSignatureFullScreen from "../../../components/pures/signature-request-detail/custom-signature-full-screen";
import PdfFullScreen from "../../../components/pures/signature-request-detail/pdf-full-screen";
import DeviceOrientation, { Orientation } from "react-screen-orientation";
import {
  ConfiguracionImage,
  newCerrarSesionIcon,
  newConsultayValidacionesIcon,
  newInboxIcon,
  newSolicitudDeFirmaIcon,
} from "../../../assets/logos/icons";
import Ding from "../../../assets/sound/ding-ding-sound-effect.mp3";
import { MuiThemeProvider } from "@material-ui/core";
import { theme } from "../../../Theme";
import { LogoColor } from "../../../assets/assets";

class AppAction extends React.Component {

  token = {};
  url = process.env.REACT_APP_MIFIRMA_API;
  urlBlog = process.env.REACT_APP_BLOG_MIFIRMA_URI;
  localStorageService = new LocalStorageService();
  cacheStorageService = new CacheStorageService();
  auth0Service = new Auth0Service();
  userDocService = new UserDocService(this.url);
  signerService = new SignerService(this.url);
  contractService = new ContractService(this.url);
  clientService = new ClientService(this.url);
  helpSectionService = new HelpSectionService(this.url);
  blogA3FirmaDigitalService = new BlogA3FirmaDigitalService(this.urlBlog);
  userSignatureProfileService = new UserSignatureProfileService(this.url);
  bovedaApi = new BovedaApi(process.env.REACT_APP_MIFIRMA_API);
  userService = new UserService(process.env.REACT_APP_MIFIRMA_API);
  updateToken = new UpdateToken(process.env.REACT_APP_MIFIRMA_API);
  notificationSocketService = new NotificationSocketService(
    process.env.REACT_APP_MIFIRMA_API
  );
  contractorService = new ContractorService(this.url)

  state = {
    expanded: true,
    userType: {},
    selectedId: 0,
    tokenHasBeenUpdated: false,
    itemsRecived: [],
    userName: "",
    selectedFileKey: null,
    selectedFileCer: null,
    selectedFileKeyName: "",
    selectedFileCerName: "",
    errorFileKey: false,
    errorFileCer: false,
    errorPassword: false,
    visibleDialogCreateDigitalSign: false,
    showLoadingRequesting: false,
    showCompletedRequesting: false,
    showErrorRequesting: false,
    showWarningRequesting: false,
    waitingVerification: true,
    contract: true,
    verified: false,
    loading: true,
    showError: false,
    verifiedSignRequest: false,
    visibleDialogTimerSignOff: false,
    showClosingSession: false,
    intervalId: "",
    timeRemaining: "",
    userContinueAnyway: false,
    loadignMessage: "",
    logo: null,
    helpSection: "",
    helpSectionFirstsFaqs: [],
    helpSectionFirstVideo: "",
    helpSectionSelect: "",
    showHelpSection: false,
    showHelpSectionSelect: false,
    initializeHelpSection: false,
    showNotification: false,
    initializeNotification: false,
    highPriority: false,
    notification: [],
    notificationQuantity: 0,
    soundActive: true,
    lastPostImg: "",
    lastPostDate: "",
    lastPostTitle: "",
    lastPostDescription: "",
    lastPostSeeMore: "",
    titleFooter: this.props.t("promotionalFooterPure.titleContact"),
    userProfiles: [],
    userPathImage: "",
    matchMobileResolution: window.matchMedia("(max-width: 500px)").matches,
    message: ""
  };

  items = [
    {
      target: 1,
      text: this.props.t("app.action.request"),
      icon: newInboxIcon,
      parentId: 1,
      route: "/",
      selected: true,
      tooltipText: this.props.t("app.action.descriptionSendRequest"),
    },
    {
      target: 3,
      text: this.props.t("app.action.dashboard"),
      icon: "https://a3cloud-development.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/menu-icons/menu_contracts.png",
      parentId: 1,
      route: "/digital-library/:route",
      tooltipText: this.props.t("app.action.contractsGrcTooltipText"),
    },
    {
      target: 4,
      text: this.props.t("app.action.signatureRequests"),
      icon: newSolicitudDeFirmaIcon,
      parentId: 1,
      route: "/signature-request-module",
      tooltipText: this.props.t("app.action.toolTipSignatureRequests"),
    },
    // {
    //   target: 5,
    //   text: this.props.t("app.action.digitalVault"),
    //   icon: "https://a3cloud-development.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/menu-icons/menu_digital_vault.png",
    //   parentId: 1,
    //   route: "/digital-vault-grc",
    //   tooltipText: this.props.t("app.action.digitalVaultTooltipText"),
    // },
    {
      target: 6,
      text: this.props.t("app.action.digitalVault"),
      icon: "https://a3cloud-development.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/menu-icons/menu_digital_vault.png",
      parentId: 1,
      route: "/digital-vault/:route",
      tooltipText: this.props.t("app.action.digitalVaultTooltipText"),
    },
    {
      target: 7,
      text: this.props.t("app.action.helpDesk"),
      icon: "https://a3cloud-quality.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/images/icon_mesadetrabajo.svg",
      parentId: 1,
      route: "/help-desk",
      tooltipText: this.props.t("app.action.queriesAndValidationDescription"),
    },
    {
      target: 8,
      text: this.props.t("app.action.queriesAndValidations"),
      icon: newConsultayValidacionesIcon,
      parentId: 1,
      route: "/queries-and-validations",
      tooltipText: this.props.t("app.action.queriesAndValidationDescription"),
    },
    {
      target: 9,
      text: this.props.t("app.action.logout"),
      icon: newCerrarSesionIcon,
      parentId: 1,
      route: "/close-session",
      tooltipText: this.props.t("app.action.logoutTooltipText"),
    },
  ];

  drawerProps = {
    position: "start",
    mode: "push",
    mini: true,
  };

  componentDidMount = async () => {
    let user = await this.localStorageService.getLocalStorageItem("user");
    this.token = await this.localStorageService.getLocalStorageItem("token")
      .idToken;
    //check if is first time in hibou and have some hibou plans and conect to contracts or boveda
    // let isFirstTimeInibou = await this.localStorageService.getLocalStorageItem(
    //   "plansHibouFlag"
    // );
    let userEmail = user.userMetaData.userA3Cloud.email;
    // if (isFirstTimeInibou && isFirstTimeInibou.planHibouExist === true) {
    // let userInfoHibou = await this.userService.getPasswordUserFromHibou(
    //   userEmail,
    //   this.token
    // );
    // let passwordUser =
    //   userInfoHibou && userInfoHibou?.data?.data?.data?.password
    //     ? userInfoHibou.data.data.data.password
    //     : "";

    //check if user has hibou plan and conect to conrtacts an boveda
    // if (isFirstTimeInibou.hibouPlan === true) {
    //   let loginGrcBoveda = await this.bovedaApi.bovedaApiLogin(
    //     userEmail,
    //     passwordUser
    //   );
    //   if (
    //     loginGrcBoveda.data.status === 200 &&
    //     loginGrcBoveda.data.data !== ""
    //   ) {
    //     let dataloginGrcBoveda = {
    //       access_token: loginGrcBoveda.data.data.access_token,
    //       user: loginGrcBoveda.data.data.user,
    //       password: loginGrcBoveda.data.data.password,
    //     };
    //     this.localStorageService.setLocalStorageItem(
    //       "bovedaToken",
    //       dataloginGrcBoveda
    //     );
    //     this.localStorageService.setLocalStorageItem(
    //       "bovedaflagActive",
    //       false
    //     );
    //   }
    // }

    //check if user has boveda plan and conect to boveda
    // if (isFirstTimeInibou.bovedaPlan === true) {
    //   let loginGrcBoveda = await this.bovedaApi.bovedaApiLogin(
    //     userEmail,
    //     passwordUser
    //   );
    //   if (
    //     loginGrcBoveda.data.status === 200 &&
    //     loginGrcBoveda.data.data !== ""
    //   ) {
    //     let dataloginGrcBoveda = {
    //       access_token: loginGrcBoveda.data.data.access_token,
    //       user: loginGrcBoveda.data.data.user,
    //       password: loginGrcBoveda.data.data.password,
    //     };
    //     this.localStorageService.setLocalStorageItem(
    //       "bovedaToken",
    //       dataloginGrcBoveda
    //     );
    //     this.localStorageService.setLocalStorageItem(
    //       "bovedaflagActive",
    //       false
    //     );
    //   }
    // }
    // }

    // let bovedaToken = await this.localStorageService.getLocalStorageItem(
    //   "bovedaToken"
    // );
    let modules = await this.localStorageService.getLocalStorageItem("modules");
    this.token = await this.localStorageService.getLocalStorageItem("token")
      .idToken;
    let accessToken = await this.localStorageService.getLocalStorageItem(
      "token"
    ).access_token;
    let timezone = await this.localStorageService.getLocalStorageItem(
      "timezone"
    );

    let contract = await this.localStorageService.getLocalStorageItem("contractUserExist");
    contract = contract || null

    let logo = await this.localStorageService.getLocalStorageItem("clientLogo");
    let helpSection =
      await this.helpSectionService.getHelpSectionDigitalSignApp(this.token);
    let userProfiles =
      await this.userSignatureProfileService.getUserSignatureProfiles(
        this.token,
        user.userMetaData.userMifirma.id
      );

    let browserId = LocalStorageService.retrieveItem("browserId")
    if (!browserId) {
      browserId = uuid()
      LocalStorageService.storeItem("browserId", browserId)
    }

    socket.emit("onLogin", {
      email: userEmail,
      access_token: accessToken,
      browserId
    });

    socket.on("notifications", (data) => {
      this.onUpdateSocket(data.data);
    });

    socket.on("closeSession", async () => {
      await this.socketLogout()
    })

    socket.on("updateVolumeStatus", (value) => {
      let user = this.localStorageService.getLocalStorageItem("user");
      user.userMetaData.userMifirma.usingVolumeSign = value
      this.localStorageService.setLocalStorageItem("user", user)
    })

    // let lastPostInfo =
    //   await this.blogA3FirmaDigitalService.getLastPostFromBlogA3FirmaDigital(
    //     this.token
    //   );
    let lastPostInfo = null;
    if (lastPostInfo !== null) {
      this.localStorageService.setLocalStorageItem(
        "lastPostInfo",
        lastPostInfo
      );
      this.localStorageService.setLocalStorageItem(
        "lastPostInfoImg",
        lastPostInfo.image
      );
      let blog = await this.localStorageService.getLocalStorageItem(
        "lastPostInfo"
      );
      let postDate = this.blogA3FirmaDigitalService.formatDateAndMonth(
        blog[0].date
      );
      this.localStorageService.setLocalStorageItem("postDate", postDate);
    }

    this.newImage = this.localStorageService.getLocalStorageItem("newImage");

    /* Se valida el acceso al modulo de Contrato Digital; MR 21-06-2023 */
    let roleActive = false
    for (let index = 0; index < user.userMetaData.userRoles.length; index++) {
      if (user.userMetaData.userRoles[index].role.key === process.env.REACT_APP_ROLE_HIBOUDIGITAL_CONTRACT_ADMIN || user.userMetaData.userRoles[index].role.key === process.env.REACT_APP_ROLE_HIBOUDIGITAL_CONTRACT_MANAGER || user.userMetaData.userRoles[index].role.key === process.env.REACT_APP_ROLE_HIBOUDIGITAL_CONTRACT_MEMBER || user.userMetaData.userRoles[index].role.key === process.env.REACT_APP_ROLE_HIBOUDIGITAL_CONTRACT_SUPER_LAWYER) {
        roleActive = true
      }
    }
    if (!roleActive) {
      let indexDelete = this.items.findIndex(
        (item) => Number(item.target) === 3
      );
      this.items.splice(indexDelete, 1);

    }

    let isInvited = false
    for (let index = 0; index < user.userMetaData.userRoles.length; index++) {
      if (user.userMetaData.userRoles[index].role.key === process.env.REACT_APP_ROLE_HIBOUDIGITAL_INVITED) {
        isInvited = true
      }
    }

    if (isInvited) {
      const isInvitedREPSE = await this.contractorService.verifyInvitedisREPSE(userEmail, this.token)
      if (isInvitedREPSE && isInvitedREPSE.data.isInvitedREPSE !== true) {
        this.items.splice(this.items.findIndex(
          (item) => Number(item.target) === 8
        ), 1);
      }
    }

    /* Validate the routes alowed in modules of user session */
    let itemsApplication = this.items;
    let itemsCurrent = [];

    for (let i = 0; i < itemsApplication.length; i++) {
      if (itemsApplication[i].hasOwnProperty("route") === true) {
        for (let j = 0; j < modules.length; j++) {
          if (itemsApplication[i].route === modules[j].module.path) {
            if (
              userProfiles.data.length <= 0 &&
              (modules[j].module.path === "/queries-and-validations" || modules[j].module.path === "/signature-request-module")
            ) {
              continue;
            } else {
              itemsCurrent.push({
                icon: modules[j].module.icon,
                route: modules[j].module.path,
                text: itemsApplication[i].text,
                selected: itemsApplication[i].selected,
                tooltipText: itemsApplication[i].tooltipText,
                target: itemsApplication[i].target,
                parentId: itemsApplication[i].parentId,
              });
              break;
            }
          }
        }
      } else {
        itemsCurrent.push(itemsApplication[i]);
      }
    }

    //Get user role keys
    const userRoles = new Set([...this.localStorageService.getLocalStorageItem("user").userMetaData.userRoles.map(item => item.role.key)])

    //Validate if have minimum digitalVaultRol
    const validDigitalVaultRol = new Set([...process.env.REACT_APP_DIGITAL_VAULT_VALID_ROLES.split(",")])

    let showDigitalVault

    //Search if user have valid role
    userRoles.forEach((item) => {
      if (showDigitalVault) return
      const haveAtLeast1Role = validDigitalVaultRol.has(item)
      if (haveAtLeast1Role) {
        showDigitalVault = true
        return
      }
    })

    if (roleActive) {
      const itemContract = itemsCurrent.find(item => item.route === "/digital-library/:route")
      itemContract.route = "/digital-library/reports"
    }

    //Validating
    if (!showDigitalVault) {
      const routeFound = itemsCurrent.find(item => item.route === "/digital-vault/:route")
      if (routeFound) itemsCurrent.splice(itemsCurrent.findIndex(item => item.route === "/digital-vault/:route"), 1)
    } else {
      const haveDigitalVault = itemsCurrent.find(item => item.route === "/digital-vault/:route")
      haveDigitalVault.route = "/digital-vault/home"
    }

    if (user.clientId !== 2) {
      const preferences = await this.clientService.getClientPreferences(this.token, timezone)
      if (preferences.statusCode === 200) {
        this.localStorageService.setLocalStorageItem('preferences', preferences.data)
        const footerPreference = !!preferences.data.find(preference => preference.preferenceName === process.env.REACT_APP_PREFERENCE_FOOTER && preference.booleanValue)
        if (footerPreference) this.localStorageService.setLocalStorageItem("footerEnabled", true)
      }
    }


    /* Add the information to help section */
    if (helpSection) {
      let countFaqs = 0;
      let helpSectionFirstsFaqs = [];
      let helpSectionFirstVideo = "";
      let firstVideoAdded = false;
      for (let i = 0; i < helpSection.length; i++) {
        /* Add an icon if it is empty in a helpSection */
        if (helpSection[i].icon === null || helpSection[i].icon === "") {
          helpSection[i].icon = ConfiguracionImage;
        }

        /* Add aditional validations to show and hide faqs and videos */
        if (helpSection[i].helpSectionFaq.length > 0) {
          for (let j = 0; j < helpSection[i].helpSectionFaq.length; j++) {
            if (countFaqs >= 3) break;
            helpSection[i].helpSectionFaq[j].showFaqItem = false;
            helpSectionFirstsFaqs.push(helpSection[i].helpSectionFaq[j]);
            countFaqs += 1;
          }
        }
        if (
          helpSection[i].helpSectionVideos.length > 0 &&
          firstVideoAdded === false
        ) {
          // Add a random video of the first helpSection (if the list has 2 elements only can select 1 or 2)
          let idRandom =
            Math.floor(
              Math.random() * (helpSection[i].helpSectionVideos.length - 0)
            ) + 0;
          for (let k = 0; k < helpSection[i].helpSectionVideos.length; k++) {
            if (idRandom === k) {
              helpSectionFirstVideo = helpSection[i].helpSectionVideos[k];
              firstVideoAdded = true;
            }
          }
        }
      }
      this.setState({
        helpSectionFirstsFaqs,
        helpSectionFirstVideo,
      });
    }
    /* Fill User, Contract and Modules validated information in state */
    let userType = user.userMetaData.userMifirma
      ? user.userMetaData.userMifirma.userType
      : {};
    window.location.hash = "";
    let intervalId = setInterval(this.onSignOffByTimerEnd, 1000);

    let userInformation = user.userMetaData.userA3Cloud;

    let image;
    this.newImage
      ? (image = this.newImage)
      : userInformation.profilePicture
        ? (image = userInformation.profilePicture)
        : (image = user.userMetaData.userAuth0.picture);

    let pathImage = `${image}`;

    const handler = (e) => this.setState({ matchMobileResolution: e.matches });
    window.matchMedia("(max-width: 500px)").addEventListener("change", handler);

    await this.setState({
      userType,
      itemsRecived: itemsCurrent,
      userName: `${user.userMetaData.userA3Cloud.firstName} ${user.userMetaData.userA3Cloud.firstLastName}`,
      loading: false,
      contract,
      intervalId,
      logo,
      helpSection,
      userProfiles: userProfiles.data,
      userPathImage: pathImage,
    });
  };

  /**
   * @author Alan Aguilar
   * @description componentDidMoun to update the component App
   * @updatedDate 11-05-2021
   * @memberof AppAction
   */
  componentWillUnmount = async () => {
    clearInterval(this.state.intervalId);
  };

  /**
   * @author Alan Aguilar
   * @description Method to show the loading dialog modal
   * @date 22-10-2020
   * @memberof RegisterUserInvitedAction
   */
  toggleLoadingRequesting = (value) => {
    this.setState({
      showLoadingRequesting: value,
    });
  };

  /**
   * @author Alan Aguilar
   * @description Method to show the loading dialog modal
   * @date 22-10-2020
   * @memberof RegisterUserInvitedAction
   */
  toggleWarningRequesting = (value) => {
    this.setState({
      showWarningRequesting: value,
    });
  };

  /**
   * @author Alan Aguilar
   * @description Method to show the complete request dialog modal
   * @date 22-10-2020
   * @memberof RegisterUserInvitedAction
   */
  toggleCompletedRequesting = (value, redirect) => {
    this.setState(
      {
        showCompletedRequesting: value,
      },
      () => {
        setTimeout(() => {
          this.setState({ showCompletedRequesting: false });
          if (redirect === true) window.location.reload();
        }, 3000);
      }
    );
  };

  /**
   * @author Alan Aguilar
   * @description Method to show the Error request dialog modal
   * @date 22-10-2020
   * @memberof RegisterUserInvitedAction
   */
  toggleErrorRequesting = (value) => {
    this.setState(
      {
        showErrorRequesting: value,
      },
      () => {
        setTimeout(() => {
          this.setState({ showErrorRequesting: false });
        }, 3000);
      }
    );
  };

  async fetchClientImage() {
    let result = await this.clientService.getClientImage(this.token);
    return result?.data?.image;
  }

  handleClick = (event) => {
    this.setState({ selectedId: 0 });
    let myStorage = window.localStorage;
    const tabSelected = {
      buttonFilterSelectedBlue: "table-button-blue-active",
      buttonFilterSelectedGreen: "",
      buttonFilterSelectedRed: "",
      buttonFilterSelectedOrange: "",
      buttonFilterSelectedGray: "",
    };
    myStorage.setItem("tabSelected", JSON.stringify(tabSelected));
    window.location.hash = "";
  };

  /**
   * @author Alan Aguilar
   * @description Method to show the closing session dialog modal
   * @updatedDate 11-05-2020
   * @memberof AppAction
   */
  toggleClosingSession = (value) => {
    this.setState({
      showClosingSession: value,
    });
  };

  /**
   * @author Alan Aguilar
   * @description Method to show and hide the Timer to close sesion
   * @updatedDate 11-05-2020
   * @memberof AppAction
   */
  toggleDialogTimerSignOff = () => {
    this.setState({
      visibleDialogTimerSignOff: !this.state.visibleDialogTimerSignOff,
      userContinueAnyway: true,
    });
  };

  /**
   * @author Alan Aguilar
   * @description Method to show and hide the Drawer Help Section
   * @updatedDate 09-09-2021
   * @memberof AppAction
   */
  toggleHelpSection = () => {
    this.setState(
      {
        initializeHelpSection: true,
      },
      () => {
        setTimeout(() => {
          this.setState({
            showHelpSection: !this.state.showHelpSection,
            showNotification: false,
          });
        }, 100);
      }
    );
  };

  /**
   * @author Adrian Montemayor
   * @description Method to show and hide the Drawer Notification Section
   * @updatedDate 02-01-2023
   * @memberof AppAction
   */
  toggleNotification = () => {
    this.setState(
      {
        initializeNotification: true,
      },
      () => {
        setTimeout(() => {
          this.setState({
            showNotification: !this.state.showNotification,
            showHelpSection: false,
          });
        }, 100);
      }
    );
  };

  onUpdateSocket = async (notificationSocket) => {
    this.setState({
      highPriority: notificationSocket.highPriority,
      notification: notificationSocket.notification,
      notificationQuantity: notificationSocket.notificationQuantity,
    });
  };

  onUpdateNotification = async (notificationId, notificationParams) => {
    this.token = await this.localStorageService.getLocalStorageItem("token")
      .idToken;

    await this.notificationSocketService.updateNotificationSocket(
      Number(process.env.REACT_APP_NOTIFICATION_ACTION_UPDATE),
      notificationId,
      notificationParams,
      this.token
    );

    return true;
  };

  /**
   * @author Adrian Montemayor
   * @description Method to mute or unmute
   * @updatedDate 02-01-2023
   * @memberof AppAction
   */
  toggleSoundActive = () => {
    this.setState({
      soundActive: !this.state.soundActive,
    });
  };

  /**
   * @author Alan Aguilar
   * @description Method to show and hide the questions-answer of each item
   * @updatedDate 14-09-2021
   * @param {Object} item
   * @memberof AppAction
   */
  toggleHelpSectionQuestionAnswer = (item, listState) => {
    // If the faqs selected are in helpSectionFirstsFaqs
    if (listState === "firstFaqs") {
      if (
        !this.state.helpSectionFirstsFaqs ||
        this.state.helpSectionFirstsFaqs.length <= 0
      )
        return false;
      for (let i = 0; i < this.state.helpSectionFirstsFaqs.length; i++) {
        if (this.state.helpSectionFirstsFaqs[i].id === item.id) {
          let tempState = [...this.state.helpSectionFirstsFaqs]; // 1.- Copiar el array del state
          let tempElement = { ...this.state.helpSectionFirstsFaqs[i] }; // 2.- Copiar el elemento del array que quieres modificar
          tempElement.showFaqItem = tempElement.showFaqItem ? false : true; // 3.- Actualiza la propiedad del elemento a modicicar
          tempState[i] = tempElement; // 4.- Almacena el elemento en el array copiado
          this.setState({
            helpSectionFirstsFaqs: tempState, // 5.- Almacena el array copiado-modificado en el state
          });
          break;
        }
      }
      // If the faqs selected are in helpSectionSelect
    } else if (listState === "selectedFaqs") {
      if (
        !this.state.helpSectionSelect ||
        this.state.helpSectionSelect.helpSectionFaq.length <= 0
      )
        return false;
      for (
        let i = 0;
        i < this.state.helpSectionSelect.helpSectionFaq.length;
        i++
      ) {
        if (this.state.helpSectionSelect.helpSectionFaq[i].id === item.id) {
          let tempState = [...this.state.helpSectionSelect.helpSectionFaq];
          let tempElement = {
            ...this.state.helpSectionSelect.helpSectionFaq[i],
          };
          tempElement.showFaqItem = tempElement.showFaqItem ? false : true;
          tempState[i] = tempElement;
          this.setState({
            helpSectionSelect: {
              ...this.state.helpSectionSelect,
              helpSectionFaq: tempState,
            },
          });
          break;
        }
      }
    }
  };

  /**
   * @author Alan Aguilar
   * @description Method to load a section selected and its information
   * @updatedDate 13-09-2021
   * @param {Object} section
   * @memberof AppAction
   */
  onSelectHelpSection = (section) => {
    this.setState({
      helpSectionSelect: section,
      showHelpSectionSelect: true,
    });
  };

  /**
   * @author Alan Aguilar
   * @description Method to return to the general help section in the panel Help Section
   * @updatedDate 13-09-2021
   * @memberof AppAction
   */
  onClickReturnHelpSection = () => {
    this.setState({
      helpSectionSelect: "",
      showHelpSectionSelect: false,
    });
  };

  /**
   * @author Alan Aguilar
   * @description Method to load and show the next help section of current helpSection selected
   * @updatedDate 13-09-2021
   * @param {Object} section
   * @memberof AppAction
   */
  onClickNextHelpSection = (section) => {
    let lastHelpSection =
      this.state.helpSection[this.state.helpSection.length - 1];
    if (section.id === lastHelpSection.id) {
      this.setState({
        helpSectionSelect: this.state.helpSection[0],
        showHelpSectionSelect: true,
      });
      return true;
    }

    for (let i = 0; i < this.state.helpSection.length; i++) {
      if (this.state.helpSection[i].id === section.id) {
        let nextHelpSection = this.state.helpSection[i + 1];
        this.setState({
          helpSectionSelect: nextHelpSection,
          showHelpSectionSelect: true,
        });
        break;
      }
    }
  };

  /**
   * @author Alan Aguilar
   * @description Method to get the file key
   * @param {Event} event
   * @memberof RegisterUserInvitedAction
   */
  handleFileKey = (e) => {
    if (e.target.files.length > 0) {
      let filename = e.target.files[0].name;
      let filenameArray = filename.split(".");
      let extension = filenameArray[filenameArray.length - 1];

      if (extension === "key" || extension === "pem") {
        this.setState({
          selectedFileKey: e.target.files[0],
          errorFileKey: false,
          selectedFileKeyName: filename,
        });
      } else {
        this.setState({
          selectedFileKey: null,
          errorFileKey: true,
          selectedFileKeyName: this.props.t("app.action.selectedFileKeyName"),
        });
        return false;
      }
    } else {
      return false;
    }
  };

  /**
   * @author Alan Aguilar
   * @description Method to close sesion if the user accept
   * @updatedDate 18-05-2020
   * @memberof AppAction
   */
  onSignOffByTimerEnd = () => {
    // if(this.tokenHasBeenUpdated === true) {
    let timeSessionLS =
      this.localStorageService.getLocalStorageItem("timeSession");
    let sessionEnds =
      timeSessionLS && timeSessionLS.timeSessionEnd
        ? timeSessionLS.timeSessionEnd
        : "";

    let timeSessionEnd = new Date(sessionEnds);
    let timeSessionCurrent = new Date();

    let msTimeEnd = timeSessionEnd.getTime();
    let msTimeCurrent = timeSessionCurrent.getTime();
    let msDif = msTimeEnd - msTimeCurrent;
    let dif = msDif / 1000;
    let timeRemaining = Math.ceil(Math.abs(dif));
    // }
    if (timeSessionCurrent >= timeSessionEnd || timeRemaining <= 0) {
      this.onSignOffByUser();
      return true;
    }
    if (timeRemaining <= 60 && this.state.userContinueAnyway === false) {
      this.setState({
        visibleDialogTimerSignOff: true,
      });
    }
    if (this.state.visibleDialogTimerSignOff) {
      this.setState({ timeRemaining });
    }
  };

  /**
   * @author Alan Aguilar
   * @description Method to refresh the user sesion token
   * @updatedDate 26-08-2021
   * @memberof AppAction
   */
  onRefreshUserToken = async () => {
    try {
      await this.toggleLoadingRequesting(true);

      this.setState({
        visibleDialogTimerSignOff: false,
        userContinueAnyway: true,
      });
      let user = await this.localStorageService.getLocalStorageItem("user");
      let userEmail = user.userMetaData.userA3Cloud.email;

      let update_token = await this.updateToken.updateToken(
        userEmail,
        this.token
      );
      await this.localStorageService.setLocalStorageItem(
        "token",
        update_token.data.data
      );
      this.token = await this.localStorageService.getLocalStorageItem("token");

      await this.localStorageService.timerSession(this.token);
      this.token = await this.localStorageService.getLocalStorageItem("token")
        .idToken;

      setTimeout(async () => {
        await this.toggleLoadingRequesting(false);
        await this.toggleCompletedRequesting(true, false);
      }, 2000);
    } catch (error) {
      return false;
    }
  };

  /**
   * @author Alan Aguilar
   * @description Method to close sesion if the user accept
   * @updatedDate 26-08-2021
   * @memberof AppAction
   */
  onSignOffByUser = async () => {
    try {
      await this.toggleClosingSession(true);
      this.setState({
        visibleDialogTimerSignOff: false,
        loadignMessage: "Cerrando sesión...",
      });
      await this.toggleLoadingRequesting(true);

      setTimeout(async () => {
        let logo = await this.localStorageService.getLocalStorageItem(
          "clientLogo"
        );
        let preferredLanguage = this.localStorageService.getLocalStorageItem("preferredLanguage")
        await this.localStorageService.setLocalStorageItem('clientLogo', logo ? logo : '')

        await this.localStorageService.clearLocalStorage();
        await this.localStorageService.setLocalStorageItem("clientLogo", logo);
        await this.localStorageService.setLocalStorageItem('preferredLanguage', preferredLanguage ?? 'es')

        this.auth0Service.logout();
        await this.toggleLoadingRequesting(false);
      }, 2000);
    } catch (error) {
      return false;
    }
  };

  /**
   * @author Alan Aguilar
   * @description Method to get the file cer
   * @param {Event} event
   * @memberof RegisterUserInvitedAction
   */
  handleFileCer = (e) => {
    if (e.target.files.length > 0) {
      let filename = e.target.files[0].name;
      let filenameArray = filename.split(".");
      let extension = filenameArray[filenameArray.length - 1];

      if (extension === "cer" || extension === "pem") {
        this.setState({
          selectedFileCer: e.target.files[0],
          errorFileCer: false,
          selectedFileCerName: filename,
        });
      } else {
        this.setState({
          selectedFileCer: null,
          errorFileCer: true,
          selectedFileCerName: this.props.t("app.action.selectedFileCerName"),
        });
        return false;
      }
    } else {
      return false;
    }
  };

  /**
   * @author Alan Aguilar
   * @description Method for delete the error from the state
   * @param {Event} event
   * @memberof RegisterUserInvitedAction
   */
  clearErrors = () => {
    this.setState({
      errorFileKey: false,
      errorFileCer: false,
      errorPassword: false,
    });
  };

  /**
   * @author Alan Aguilar
   * @description Method submit to create the digital sign for a user
   * @date 22-10-2020
   * @memberof RegisterUserInvitedAction
   */
  onCreateDigitalSign = async (dataItem) => {
    try {
      await this.toggleLoadingRequesting(true);
      await this.clearErrors();

      // Validate if the files key or cer have errors
      if (
        this.state.errorFileKey === true ||
        this.state.errorFileCer === true
      ) {
        this.setState({ errorFileKey: true, errorFileCer: true });
        await this.toggleLoadingRequesting(false);
        await this.toggleErrorRequesting(true);
        return false;
      }

      // Validate if the password was provided
      if (dataItem.password.length <= 0) {
        return false;
      }

      let { selectedFileKey, selectedFileCer } = this.state;
      let createDigitalSignData = new FormData();
      createDigitalSignData.append("password", dataItem.password);
      createDigitalSignData.append("fileKEY", selectedFileKey);
      createDigitalSignData.append("fileCER", selectedFileCer);

      let createDigitalSignUser =
        await this.signerService.createDigitalSignUser(
          createDigitalSignData,
          this.token
        );
      if (!createDigitalSignUser.data) {
        await this.toggleLoadingRequesting(false);
        await this.toggleErrorRequesting(true);
        throw new Error("Error in the request");
      }

      await this.toggleLoadingRequesting(false);
      await this.toggleCompletedRequesting(true, true);
    } catch (error) {
      return false;
    }
  };

  handleButtonLogOut = async () => {

    let logo = await this.localStorageService.getLocalStorageItem("clientLogo");
    let preferredLanguage = this.localStorageService.getLocalStorageItem("preferredLanguage")
    await this.localStorageService.clearLocalStorage();
    await this.cacheStorageService.clearCache();
    await this.localStorageService.setLocalStorageItem(
      "clientLogo",
      logo ? logo : ""
    );
    this.localStorageService.setLocalStorageItem("preferredLanguage", preferredLanguage ?? "es")
    this.auth0Service.logout();
  };

  socketLogout = async () => {
    this.setState({ message: "Se ha iniciado sesión en otro dispositivo u otro navegador, se cerrará esta sesión. Si no eres tú, te recomendamos cambiar tu contraseña.", showWarningRequesting: true })
    setTimeout(async () => {
      let logo = await this.localStorageService.getLocalStorageItem("clientLogo");
      await this.localStorageService.clearLocalStorage();
      await this.cacheStorageService.clearCache();
      await this.localStorageService.setLocalStorageItem(
        "clientLogo",
        logo ? logo : ""
      );
      LocalStorageService.storeItem("browserId",)
      this.setState({ message: "", showWarningRequesting: false })
      this.auth0Service.logout();
    }, 3000)
  };

  setSelectedItem = (event) => {
    this.setState({ selectedId: 0 });
    let myStorage = window.localStorage;
    const tabSelected = {
      buttonFilterSelectedBlue: "table-button-blue-active",
      buttonFilterSelectedGreen: "",
      buttonFilterSelectedRed: "",
      buttonFilterSelectedOrange: "",
      buttonFilterSelectedGray: "",
    };
    myStorage.setItem("tabSelected", JSON.stringify(tabSelected));
    window.location.hash = "";
  };

  /**
   * @author Alan Aguilar
   * @description Handler method to change of page in the Drawer component
   * @updatedDate 05-05-2021
   * @memberof AppAction
   */
  onSelect = (event, history) => {
    let userCanAccessRoute;
    let { route } = event.itemTarget.props;
    let { contractExist, userHadContracts, contractsStatus } =
      this.state.contract.data;

    // If user has an active and aprove contract (common login)
    if (
      contractExist === true &&
      contractsStatus ===
      Number(process.env.REACT_APP_USER_CONTRACT_STATUS_APROVED)
    ) {
      userCanAccessRoute = true;

      // If user does not has a contract or is disble but had a contract aprovated proviously
    } else if (
      contractExist === false &&
      userHadContracts === true &&
      contractsStatus ===
      Number(process.env.REACT_APP_USER_CONTRACT_STATUS_APROVED)
    ) {
      userCanAccessRoute = route === "/sign-request" ? false : true;

      // If the user contract exist and hab contrasct prevously but is pending to aprove
    } else if (
      contractExist === true &&
      userHadContracts === true &&
      contractsStatus ===
      Number(process.env.REACT_APP_USER_CONTRACT_STATUS_PENDING)
    ) {
      userCanAccessRoute =
        route === "/sign-request" || route === "/configuration" ? false : true;

      // If user has a contract expired and had a contract proviously but are expired or rejected
    } else if (
      contractExist === true &&
      userHadContracts === true &&
      (contractsStatus ===
        Number(process.env.REACT_APP_USER_CONTRACT_STATUS_EXPIRED) ||
        contractsStatus ===
        Number(process.env.REACT_APP_USER_CONTRACT_STATUS_REJECTED))
    ) {
      userCanAccessRoute = route === "/sign-request" ? false : true;

      // If the user does not has a contract but is a user Invited
    } else if (
      contractExist === false &&
      this.state.userType.id ===
      Number(process.env.REACT_APP_USER_TYPE_INVITADO)
    ) {
      userCanAccessRoute =
        route === "/sign-request" || route === "/configuration" ? false : true;

      // If the user does not has a contract but is a user Collaborator
    } else if (
      contractExist === false &&
      this.state.userType.id ===
      Number(process.env.REACT_APP_USER_TYPE_COLABORADOR)
    ) {
      userCanAccessRoute = route === "/sign-request" ? false : true;
    }

    if (userCanAccessRoute === true) {
      this.setState({ selectedId: event.itemIndex });
      history.push(event.itemTarget.props.route);
    }
  };

  setSelectedItem = (pathName) => {
    let currentPath = this.items.find((item) => item.route === pathName);
    if (currentPath) {
      return currentPath.text;
    }
  };

  /**
   * @author Alan Aguilar
   * @description Handler method to check if the seletec menu option is access by contract user
   * @updatedDate 05-05-2021
   * @memberof AppAction
   */
  checkForAuthorization = (history) => {
    let { contract, verified } = this.state;

    if (
      contract.data.contractsStatus ===
      Number(process.env.REACT_APP_USER_CONTRACT_STATUS_PENDING) &&
      !verified
    ) {
      this.setState({ verified: true });
      history.push("/waiting-authorization");
    }
  };

  /**
   * @author Adrian Montemayor
   * @description Handler method to redirect an user if he is accessing from a "Sign Request Email"
   * @updatedDate 10-05-2021
   * @memberof AppAction
   */
  checkForSignRequest = (history) => {
    let { verifiedSignRequest } = this.state;
    let location = this.localStorageService.getLocalStorageItem("url");

    if (location && location !== "" && !verifiedSignRequest) {
      this.setState({ verifiedSignRequest: true });
      let signRequestPath = location.split("#")[1];
      if (signRequestPath !== "/" && signRequestPath !== "/?registered=true")
        history.push(signRequestPath);
    }
  };

  /**
   * @author Juan Manuel Lamperti
   * @description Toggle expanded prop to side menu
   * @updatedDate 30-06-2022
   * @memberof AppAction
   */

  toggleExpandedSideMenu = () => {
    this.setState({ expanded: !this.state.expanded });
  };

  /**
   * @author Adrian Montemayor
   * @description Sound ding
   * @updatedDate 30-06-2022
   * @memberof AppAction
   */

  playSound = () => {
    let ding = new Audio(Ding);
    if (this.state.soundActive) {
      ding.play();
    }
  };

  render() {
    const { innerWidth: fullWidth, innerHeight: fullHeight } = window;
    if (this.state.loading) {
      return <SimpleLoading />;
    } else {
      return (
        <SocketContext.Provider value={socket}>
          <MuiThemeProvider theme={theme}>
            <ContextProvider
              visibleDialogTimerSignOff={this.state.visibleDialogTimerSignOff}
              logo={this.state.logo}
              setShowError={(showError) => this.setState({ showError })}
            >
              {({
                showSignatureCanvas,
                canvasData,
                showPdf,
                pdf,
                setShowPdf,
                clientLogo,
                pdfSucess,
                setPdfSucess,
              }) => (
                <React.Fragment>
                  <div
                    className="main"
                    style={
                      showSignatureCanvas || showPdf ? { display: "none" } : {}
                    }
                  >
                    <Router>
                      <div className="app-menu">
                        <div
                          id="hamburger-icon"
                          className="app-menu-item-accordion-button"
                        >
                          <button
                            className="k-button k-button-md k-rounded-md k-button-flat k-button-flat-base"
                            onClick={this.toggleExpandedSideMenu}
                          >
                            <span className="k-icon k-i-menu" />
                          </button>
                        </div>
                        <div className="app-menu-item">
                          <Link
                            to={
                              this.state.contract.data.contractsStatus ===
                                Number(
                                  process.env.REACT_APP_USER_CONTRACT_STATUS_PENDING
                                )
                                ? "/waiting-authorization"
                                : "/"
                            }
                          >
                            <img
                              alt="Logo de govo.legal"
                              src={LogoColor}
                              style={{ height: "32px" }}
                            />
                          </Link>
                        </div>
                        <div className="app-menu-item">
                          <div className="app-menu-item-container">
                            <div className="app-menu-item-container-item"></div>
                            <div className="app-menu-item-container-item">
                              {clientLogo && (
                                <img
                                  style={{
                                    height: "100%",
                                    marginLeft: "25px",
                                    maxWidth: "150px",
                                  }}
                                  src={clientLogo}
                                  alt="logo"
                                />
                              )}
                            </div>
                            <div className="app-menu-item-container-item"></div>
                          </div>
                        </div>
                        <div className="app-menu-item"></div>
                      </div>
                      <div className="div-con-fondo">
                        <AppView
                          {...this.state}
                          t={this.props.t}
                          items={this.state.itemsRecived}
                          drawerProps={this.drawerProps}
                          handleButtonLogOut={this.handleButtonLogOut}
                          handleClick={this.handleClick}
                          onSelect={this.onSelect}
                          setSelectedItem={this.setSelectedItem}
                          handleFileKey={this.handleFileKey}
                          handleFileCer={this.handleFileCer}
                          toggleDialogCreateDigitalSign={
                            this.toggleDialogCreateDigitalSign
                          }
                          onCreateDigitalSign={this.onCreateDigitalSign}
                          toggleLoadingRequesting={this.toggleLoadingRequesting}
                          toggleCompletedRequesting={
                            this.toggleCompletedRequesting
                          }
                          toggleWarningRequesting={this.toggleWarningRequesting}
                          toggleErrorRequesting={this.toggleErrorRequesting}
                          checkForAuthorization={this.checkForAuthorization}
                          checkForSignRequest={this.checkForSignRequest}
                          toggleDialogTimerSignOff={this.toggleDialogTimerSignOff}
                          onSignOffByTimerEnd={this.onSignOffByTimerEnd}
                          onSignOffByUser={this.onSignOffByUser}
                          onRefreshUserToken={this.onRefreshUserToken}
                          toggleHelpSection={this.toggleHelpSection}
                          toggleNotification={this.toggleNotification}
                          playSound={this.playSound}
                          toggleSoundActive={this.toggleSoundActive}
                          onUpdateSocket={this.onUpdateSocket}
                          onUpdateNotification={this.onUpdateNotification}
                          toggleHelpSectionQuestionAnswer={
                            this.toggleHelpSectionQuestionAnswer
                          }
                          onSelectHelpSection={this.onSelectHelpSection}
                          onClickReturnHelpSection={this.onClickReturnHelpSection}
                          onClickNextHelpSection={this.onClickNextHelpSection}
                          toggleExpandedSideMenu={this.toggleExpandedSideMenu}
                        >
                          <Routes
                            showError={this.state.showError}
                            setShowError={(showError) =>
                              this.setState({ showError })
                            }
                            onInvitedRedirectRegister={
                              this.props.onInvitedRedirectRegister
                            }
                          />
                        </AppView>
                      </div>
                      {/* Footer od the page */}
                      <SimpleFooterPure />
                    </Router>
                  </div>
                  {showSignatureCanvas && (
                    <DeviceOrientation lockOrientation={"landscape"}>
                      <Orientation orientation="portrait">
                        <CustomSignatureFullScreen
                          visibleDialogTimerSignOff={
                            this.state.visibleDialogTimerSignOff
                          }
                          {...canvasData}
                        />
                      </Orientation>
                    </DeviceOrientation>
                  )}
                  {showPdf && (
                    <DeviceOrientation lockOrientation={"landscape"}>
                      <Orientation orientation="portrait">
                        <div style={{ width: fullWidth, height: fullHeight }}>
                          <PdfFullScreen
                            pdfSucess={pdfSucess}
                            setPdfSucess={setPdfSucess}
                            pdf={pdf}
                            setShowPdf={setShowPdf}
                            visibleDialogTimerSignOff={
                              this.state.visibleDialogTimerSignOff
                            }
                          >
                            <SimpleLoading />
                          </PdfFullScreen>
                        </div>
                      </Orientation>
                    </DeviceOrientation>
                  )}
                </React.Fragment>
              )}
            </ContextProvider>
          </MuiThemeProvider>
        </SocketContext.Provider>
      );
    }
  }
}

function AppActionContainer(props) {
  const { t } = useTranslation();
  return <AppAction {...props} t={t} />;
}

export { AppActionContainer as default };
